// extracted by mini-css-extract-plugin
export var actionButton = "_s8-0";
export var actionMenuContainer = "_s8-i";
export var bubble = "_s8-2";
export var bubbleActionMenu = "_s8-j";
export var bubbleContext = "_s8-6";
export var bubbleItems = "_s8-7";
export var customer = "_s8-3";
export var divider = "_s8-8";
export var fileList = "_s8-9";
export var hiddenComment = "_s8-o";
export var infoAbove = "_s8-a";
export var internal = "_s8-4";
export var lightActionButton = "_s8-1";
export var link = "_s8-b";
export var merchant = "_s8-5";
export var message = "_s8-c";
export var profilePicture = "_s8-e";
export var quillToolbarContainer = "_s8-f";
export var senderDate = "_s8-g";
export var senderDateCustomer = "_s8-h";
export var senderName = "_s8-d";
export var time = "_s8-k";
export var uploadedImage = "_s8-l";
export var username = "_s8-m";
export var xsmall = "_s8-n";